import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-lg mx-auto px-5 py-24 text-center">
      <div className="font-display text-6xl text-[#C05A3D]">404</div>
      <h1 className="font-display text-2xl text-[#1E3A2F] mt-3">This page took a detour.</h1>
      <p className="text-[#5C5C5C] mt-2">Let's get you back home.</p>
      <Link to="/" className="mt-6 inline-block rounded-full abm-btn-primary px-6 h-11 leading-[2.75rem] text-white">Go home</Link>
    </div>
  );
}
